import React from 'react';
import { BookOpenIcon, CalendarDaysIcon, ClipboardCheckIcon, ImageIcon, LayersIcon, MusicIcon } from 'lucide-react';
import { volumes, type VolumeIcon } from '../data/volumes';
import { Eyebrow } from './Eyebrow';
const icons: Record<VolumeIcon, React.ElementType> = {
  rhythm: MusicIcon,
  harmony: LayersIcon,
  standards: BookOpenIcon,
  assessment: ClipboardCheckIcon,
  cards: ImageIcon,
  planner: CalendarDaysIcon
};
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="bg-paper-100 py-16 sm:py-24" data-id="element-267" data-mp="24u5spr5dwl8j">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-268" data-mp="24rs15s9wxr5q">
        <div className="max-w-2xl" data-id="element-269" data-mp="1qtlcn2qut3iq">
          <Eyebrow data-id="element-270" data-mp="1qwpmafn38rgs">The complete system: 6 volumes</Eyebrow>
          <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-271" data-mp="1vs4yl35g6fb3">
            Six volumes
          </h2>
        </div>

        <ol className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-272" data-mp="kfvs9j1imxdt">
          {volumes.map(volume => {
          const Icon = icons[volume.icon];
          return <li key={volume.number} className="flex flex-col border border-paper-300 bg-paper p-6 sm:p-7" data-id="element-273" data-mp="3jadgzlay529d">
                <div className="flex items-center gap-4" data-id="element-274" data-mp="3t7j9mxz7l1bp">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center" style={{
                backgroundColor: volume.accent
              }} data-id="element-275" data-mp="3t5yd52tc38b7">
                    <Icon className="h-5 w-5 text-paper" aria-hidden="true" data-id="element-276" data-mp="620naaluaxo1" />
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-label text-brass-dark" data-id="element-277" data-mp="kqwqnucybmib">
                    Volume {volume.number}
                  </span>
                </div>

                <h3 className="mt-6 font-display text-xl font-semibold leading-snug text-ink sm:text-2xl" data-id="element-278" data-mp="tsnx51fbfxd8">
                  {volume.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-279" data-mp="wu97qj8sspi9">{volume.description}</p>

                <p className="mt-auto pt-6 text-xs font-semibold leading-relaxed text-ink" data-id="element-280" data-mp="11sasd8lvgwvu">
                  {volume.contents.join(' · ')}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}